import React, { useState, useEffect } from 'react';

import BurgerIcon from '../../assets/images/burger-icon.svg';
import CloseIcon from '../../assets/images/close-icon.svg';
import CopyIcon from '../../assets/images/copy-icon.png';
import VenmoLogo from '../../assets/images/venmologo.png';
import PaypalLogo from '../../assets/images/paypallogo.png';

import { useDispatch, useSelector } from 'react-redux';

import SideMenu from '../../components/SideMenu.js';
import { getUserAct } from '../../store/actions/userAction.js';
import CustomModal from '../../components/Modal/modal.js';
import { Button } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const Template = (props) => {
    const dispatch = useDispatch();
    const { user, isDemo } = useSelector((state) => state.auth);
    const [menuOpen, setMenuOpen] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    };

    useEffect(() => {
        if (user) {
            dispatch(getUserAct({ _id: user._id }))
        }

        if (menuOpen) {
            // document.body.style.overflowX = 'hidden';
            // document.body.style.overflowY = 'hidden';
            // document.documentElement.style.overflowX = 'hidden';
            // document.documentElement.style.overflowY = 'hidden';
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
    }, [menuOpen]);

    // console.log(user, 'UserInfo');
    return (
        <>
            <div className={`screen-wrapper ${menuOpen ? 'menu-open' : ''}`} >
                {
                    !isDemo &&
                    <div className='burger-icon' onClick={handleMenuToggle}>
                        <img src={menuOpen ? CloseIcon : BurgerIcon} alt="menu toggle" />
                    </div>
                }
                {
                    (!menuOpen && user) &&
                    <div style={{ position: 'absolute', left: 0, top: 60, zIndex: 2 }}>
                        <div className='profile-photo-block'>
                            <div className='profile-name-info'>
                                <h4 style={{ marginLeft: 22 }}>{user ? user.name : ''}</h4>
                            </div>
                        </div>
                        {
                            !isDemo &&
                            <div className='money-balance' onClick={() => { setModalIsOpen(true) }}>
                                <span style={{ padding: '5px 20px', fontSize: 12 }}>${user ? user.balance : '0'}</span>
                            </div>
                        }
                    </div>
                }
                {props.children}
            </div>
            {/* Side Menu */}
            <SideMenu
                menuOpen={menuOpen}
                user={user}
                handleMenuToggle={handleMenuToggle}
            />
            <CustomModal
                modalIsOpen={modalIsOpen}
                primaryColor='#0d6efd'
                setModalIsOpen={setModalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                backgroundColor='#FDDA2F'
            >
                <div className='mx-4 text-center' style={{ fontFamily: 'BigBlackBear' }}>
                    <h3>SETTLE UP</h3>
                    {user && <p style={{ fontFamily: 'arial', paddingTop: 5 }}>{user.balance < 0 ? 'YOU OWE ' : 'YOUR BALANCE '} ${user.balance < 0 ? -user.balance : user.balance}</p>}
                    <div className='d-flex justify-content-between bg-dark-subtle p-1 mt-2 px-2' style={{ fontFamily: 'Bebas Neue' }}>
                        <div className='d-flex justify-content-between align-items-center w-100'>
                            <img src={VenmoLogo} style={{ width: 35, height: 35, marginRight: 10 }} />
                            <span>@ballhog</span>
                            <div className='pr-2'>
                                <CopyToClipboard text={`@ballhog`}
                                    onCopy={() => { setCopied(true); }}>
                                    {/* <h5 style={{
                                    color: 'red', textAlign: 'center'
                                }}>Copy Link</h5> */}
                                    <img src={CopyIcon} style={{ width: 25, height: 25 }} />
                                </CopyToClipboard>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between bg-dark-subtle p-1 mt-2 px-2' style={{ fontFamily: 'Bebas Neue' }}>
                        <div className='d-flex justify-content-between align-items-center w-100'>
                            <img src={PaypalLogo} style={{ width: 35, height: 35, marginRight: 10 }} />
                            <span>payments@playballhog.com</span>
                            <div className='pr-2'>
                                <CopyToClipboard text={`payments@playballhog.com`}
                                    onCopy={() => { setCopied(true); }}>
                                    {/* <h5 style={{
                                        color: 'red', textAlign: 'center'
                                    }}>Copy Link</h5> */}
                                    <img src={CopyIcon} style={{ width: 25, height: 25 }} />
                                </CopyToClipboard>
                            </div>
                        </div>
                    </div>
                    <div className='text-center'>
                        <p style={{ fontFamily: 'arial', fontSize: 12, paddingTop: 10 }}>Settle up payments are processed on Mondays</p>
                    </div>
                    <Button className='mt-4' onClick={() => { setModalIsOpen(false) }}>CLOSE</Button>
                </div>
            </CustomModal>
            <CustomModal
                modalIsOpen={copied}
                primaryColor='#fff'
                setModalIsOpen={setCopied}
                onRequestClose={() => setCopied(false)}
                backgroundColor='#fff'
            >
                <div className='mx-4 text-center' style={{ fontFamily: 'BigBlackBear' }}>
                    {/* <h3>payments@playballhog.com</h3> */}
                    <div>
                        <p>Has been added to your clipboard to make a payment or request a payment from BALLLHOG.</p>

                        <Button className='mt-4' onClick={() => { setCopied(false) }}>CLOSE</Button>
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

export default Template;